import { Component, OnInit } from '@angular/core';
import { GenericService } from '../generic.service';
import { environment } from '../../environments/environment';
import * as _ from 'underscore';
import { NotificationService } from '../notification.service';

//import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
//import {MatPaginatorModule} from '@angular/material/paginator';


@Component({
  selector: 'app-recherche-avancee',
  templateUrl: './recherche-avancee.component.html',
  styleUrls: ['./recherche-avancee.component.css']

})

export class RechercheAvanceeComponent implements OnInit {

  public showSpinner : boolean = false;
  //public errorMessage: string;
  //public successMessage: string;
  public page : number;
  public total : number ;
  public totalPages;
  public pages;

  //Récupérer les éléments de recherches
  public critere = {
    nom : undefined,
    prenom : undefined,
    cle1: undefined,
    cle2: undefined,
    connecteur: undefined,
    noteGlobale: undefined,
    experience : undefined,
    status : undefined,
    dernierJour : undefined,
    nouvelleDate : undefined,
    candidatureNonValide : true,
    cooptationNonValide : false
  };

  public dataAvailable : boolean;
  public result : any;

  public sortDir = -1;//1= 'ASE' -1= DSC

  public  MONTION :Array<any> = [
    {label:'mv',display:'Mauvais'},
    {label:'m',display:'Moyen'},
    {label:'b',display:'Bien'},
    {label:'tb',display:'Très bien'},
  ];

  public reset : boolean;
  public sortKey :string;

  public MsgError  : String;

  constructor(private _genericService: GenericService, private _notifyService: NotificationService) { }

  ngOnInit() {
    this.MsgError = '';
  }

  ngAfterViewInit() {
   // this.dataSource.paginator = this.paginator;
  //  this.dataSource.sort = this.sortForDataSource;
  }

  public search(isValid){
    this.reset = false;
    //this.errorMessage = "";
    //this.MsgError = this.errorMessage ;
    //this.resetErrorMessage();
    if(isValid){
      this.loadPage(1, this.sortDir, 'dateDernierEntretien');
    }
  }

  loadPage(index, sortDir, sortKey){
    this.page = index;
      this.showSpinner = true;

      let body = {
        critere : this.critere,
        page :  this.page
      };
      if(body.critere.nom != undefined) {
        body.critere.nom = String(body.critere.nom).trim()
        .replace(/-/g, " ")
        .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
        .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
        .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u");
      }
      if(body.critere.prenom != undefined) {
        body.critere.prenom = String(body.critere.prenom).trim()
        .replace(/-/g, " ")
        .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
        .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
        .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u");
      }
      if(body.critere.cle1 != undefined) {
        body.critere.cle1 = String(body.critere.cle1).trim();
      }
      if(body.critere.cle2 != undefined) {
        body.critere.cle2 = String(body.critere.cle2).trim();
      }
      if(body.critere.dernierJour != undefined) {
        body.critere.nouvelleDate = new Date();
      }


      this._genericService.searchWithBody(environment.searchAvanceUrl, body, true, this.sortDir, this.sortKey)
      .subscribe(
        data => {
          if( body.critere.experience < 0){
            this._notifyService.showError("Formulaire invalide", "Search", 3000)
            //this.errorMessage = "Formulaire invalide ";
            this.showSpinner = false;
            //this.MsgError = this.errorMessage;
            //window.scrollTo(0, 0);
            //this.resetErrorMessage();
          }else{
            this.success(data)
          }
        },
        error => {
          this.showSpinner = false;
          /*this.errorMessage = error,
          this.MsgError = this.errorMessage;
          this.resetErrorMessage();*/
        }
      );
  }

  success(result){
    this.totalPages = new Array(result.pages);
    this.showSpinner = false;
    this.total = result.pages;

    let startPage: number, endPage: number;

    if (this.total <= 5) {
      startPage = 1;
      endPage = this.total;
      }
      else {
        if (this.page <= 3) {
            startPage = 1;
            endPage = 5;
        }
        else if (this.page + 1 >= this.total) {
                startPage = this.total - 4;
                endPage = this.total;
            } else {
                startPage = this.page - 2;
                endPage = this.page + 2;
            }
    }


    this.pages= _.range(startPage, endPage + 1);


    for(let row of result.data){
      row.general.dateDernierEntretien = row.general.dateDernierEntretien;
    }
    this.result = result.data;

    this.dataAvailable = true;
  }

  // Réinitier les critères de recherche
  clear(){
    this.critere.nom = undefined;
    this.critere.prenom = undefined,
    this.critere.noteGlobale = undefined,
    this.critere.cle1 = undefined,
    this.critere.cle2 = undefined,
    this.critere.connecteur = undefined,
    this.critere.dernierJour = undefined,
    this.critere.nouvelleDate = undefined,
    this.critere.experience = undefined,
    this.critere.status = undefined,
    this.critere.candidatureNonValide = true,
    this.critere.cooptationNonValide = false,
    this.reset = true

  }

  // Page suivante
  next(){
    if(this.page < this.total ){
      this.loadPage(this.page+1, this.sortDir, this.sortKey);
    }
  }

  //Page précédante
  previous(){
    if(this.page > 1){
      this.loadPage(this.page-1, this.sortDir, this.sortKey);
    }
  }

  // tri en fonction du nom
  onSortNomClick(event) {
    let target = event.currentTarget,
      classList = target.classList;
    this.sortKey = 'nom';

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir=-1;
      return this.loadPage(1, this.sortDir, this.sortKey);
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir=1;
      return this.loadPage(1, this.sortDir, this.sortKey);
    }
  }

  // tri en fonction du prenom
  onSortPrenomClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    this.sortKey = 'prenom';

    if (classList.contains('fa-chevron-up')) {
      classList.remove('fa-chevron-up');
      classList.add('fa-chevron-down');
      this.sortDir=-1;
      return this.loadPage(1, this.sortDir, this.sortKey);
    } else {
      classList.add('fa-chevron-up');
      classList.remove('fa-chevron-down');
      this.sortDir=1;
      return this.loadPage(1, this.sortDir, this.sortKey);
    }
  }




 // Tri des résultats par note générale
 onSortNoteGeneralClick(event) {
  let target = event.currentTarget,
    classList = target.classList;
 
  this.sortKey = 'noteGeneral';

  if (classList.contains('fa-chevron-up')) {
    classList.remove('fa-chevron-up');
    classList.add('fa-chevron-down');
    this.sortDir=-1;
    return this.loadPage(this.page, this.sortDir, this.sortKey);
  } else {
    classList.add('fa-chevron-up');
    classList.remove('fa-chevron-down');
    this.sortDir=1;
    return this.loadPage(this.page, this.sortDir, this.sortKey);
  }
}


  // tri en fonction de la date du dernier entretien
  onSortDateClick(event) {
    let target = event.currentTarget,
      classList = target.classList;

    this.sortKey = 'dateDernierEntretien';

      if (classList.contains('fa-chevron-up')) {
        classList.remove('fa-chevron-up');
        classList.add('fa-chevron-down');
        this.sortDir=-1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      } else {
        classList.add('fa-chevron-up');
        classList.remove('fa-chevron-down');
        this.sortDir=1;
        return this.loadPage(1, this.sortDir, this.sortKey);
      }
  }


  /*resetErrorMessage(){
    setTimeout(()=>{
      this.MsgError = '';
    }, 3000);
  }*/

  // resetSuccesMessage(){
  //   setTimeout(()=>{
  //     this.justUpdated = '';
  //   }, 3000);
  // }
}



// WEBPACK FOOTER //
// ./src/app/recherche-avancee/recherche-avancee.component.ts